import { Component, effect, HostListener, input, output } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { BehandlerListEntry } from '../model/behandler-list-entry.interface';
import { ButtonDirective, TooltipOnContentOverflowDirective } from '@ps-gui/shared-core';
import { BehandlerAssignmentData } from '@ps-gui/shared-document-preview';

@Component({
  selector: 'ct-extraction-behandler-list',
  imports: [NgOptimizedImage, ButtonDirective, TooltipOnContentOverflowDirective],
  templateUrl: './behandler-list.component.html',
  styleUrl: './behandler-list.component.scss',
})
export class BehandlerListComponent {
  readonly behandlerData = input.required<BehandlerListEntry[]>();

  readonly assignBehandlerToSelectedDocument = output<BehandlerAssignmentData>();
  readonly openBehandlerDetails = output<BehandlerListEntry>();
  readonly deleteBehandler = output<BehandlerListEntry>();

  constructor() {
    effect(() => {
      const data = this.behandlerData();
      for (const entry of data) {
        const headlineItems = [entry.einrichtung];

        if (entry.einrichtung && (entry.vorname || entry.nachname)) {
          headlineItems.push('-');
        }

        headlineItems.push(entry.titel, entry.vorname, entry.nachname);

        entry.fullHeadline = headlineItems.filter((e) => e?.length).join(' ');
      }
    });
  }

  protected onClickSkipBehandler() {
    this.assignBehandlerToSelectedDocument.emit({});
  }

  @HostListener('window:keydown.space', ['$event'])
  protected skipBehandlerKeyboardListener(event: Event) {
    event.preventDefault();
    this.onClickSkipBehandler();
  }

  @HostListener('window:keydown.n', ['$event'])
  protected addBehandlerKeyboardListener(event: Event) {
    event.preventDefault();
    this.onClickAddBehandler();
  }

  @HostListener('window:keydown', ['$event'])
  protected assignBehandlerKeyboardListener(event: KeyboardEvent) {
    const entry = this.behandlerData().find((b) => b.displayId === event.key);

    if (entry) {
      event.preventDefault();
      this.onClickBehandlerCard(entry);
    }
  }

  protected onClickBehandlerCard(entry: BehandlerListEntry) {
    this.assignBehandlerToSelectedDocument.emit({
      behandlerIndex: entry.index,
      behandlerDisplayId: entry.displayId,
    });
  }

  protected onClickAddBehandler() {
    this.openBehandlerDetails.emit({});
  }

  protected onClickEdit(event: Event, entry: BehandlerListEntry) {
    event.stopPropagation();
    this.openBehandlerDetails.emit(entry);
  }

  protected onClickDelete(event: Event, entry: BehandlerListEntry) {
    event.stopPropagation();
    this.deleteBehandler.emit(entry);
  }
}
